export default __webpack_public_path__ + "static/Minimum-Viable-Product-0c047b4da21494bcc12d834ca4cfd10d.webp";